import { render, staticRenderFns } from "./setInfo.vue?vue&type=template&id=4c9280bd&scoped=true"
import script from "./setInfo.vue?vue&type=script&lang=js"
export * from "./setInfo.vue?vue&type=script&lang=js"
import style0 from "./setInfo.vue?vue&type=style&index=0&id=4c9280bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9280bd",
  null
  
)

export default component.exports